function handleEventListeners() {
  const isMobile = window.matchMedia('(max-width: 768px)').matches
  const featuredColEl = document.querySelectorAll('featured-collection')
  
  featuredColEl.forEach((item) => {
    const items = item.querySelectorAll('.product-card')
    const btnShowMore = item.querySelector('.btn-show-more')

    if (btnShowMore) {
      if (items.length < 5 || isMobile) {
        btnShowMore.classList.add('hidden')
        return;
      }
    }

    if (item.dataset.enableSlider || isMobile) return;

    items.forEach((itemProduct, indexProduct) => {
      if (indexProduct >= 4) {
        itemProduct.classList.add('hidden')
      }  
    })

    btnShowMore.addEventListener('click', () => {
      if (btnShowMore.textContent == 'Show More') {
        btnShowMore.textContent = 'Show Less'

        items.forEach((itemProduct, indexProduct) => {
          if (indexProduct >= 4) {
            itemProduct.classList.remove('hidden')
          }  
        })
      } else {
        btnShowMore.textContent = 'Show More'

        items.forEach((itemProduct, indexProduct) => {
          if (indexProduct >= 4) {
            itemProduct.classList.add('hidden')
          }  
        })
      }
    })
  });
}

handleEventListeners()